export default __webpack_public_path__ + "static/media/DB_FI.e7675357.png";